export default "__VITE_ASSET__e348e65f__"